"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeletePacketsRequestSchema = exports.getStatusOfFinishedPacket = exports.getStatusOfCanceledPacket = exports.CreatePacketDocumentDto = exports.DashboardDocument = exports.DashboardDocumentInfoDto = exports.Base64Document = exports.CreatePacketDocumentType = exports.GetPacketsQueryParamsSchema = exports.PatchPacketRequestSchema = exports.packetStatusEnum = void 0;
const zod_1 = require("zod");
const types_1 = require("./types");
const utils_1 = require("../utils");
const signer_1 = require("./signer");
const packet_tag_1 = require("./packet_tag");
exports.packetStatusEnum = zod_1.z.union([
    zod_1.z.nativeEnum(types_1.DocumentSignatureStatusEnum),
    zod_1.z.nativeEnum(types_1.PolicyAgreementStatusEnum),
]);
exports.PatchPacketRequestSchema = zod_1.z.object({
    name: zod_1.z.string().optional(),
    status: exports.packetStatusEnum.optional(),
    tags: zod_1.z.array(packet_tag_1.PacketTagSchema).optional(),
    lock_application: zod_1.z.boolean().optional(),
    creditors: zod_1.z
        .array(zod_1.z.object({
        creditor_id: zod_1.z.string(),
        email: zod_1.z.string().nullable().optional(),
    }))
        .optional(),
});
exports.GetPacketsQueryParamsSchema = zod_1.z.object({
    external_user_ids: (0, utils_1.queryParamArray)(zod_1.z.string()).optional(),
    status_mode: zod_1.z.enum(['in', 'not_in']).optional(),
    type: (0, utils_1.queryParamArray)(zod_1.z.nativeEnum(types_1.PacketTypeEnum)),
    status_values: (0, utils_1.queryParamArray)(exports.packetStatusEnum),
    signer_status: (0, utils_1.queryParamArray)(zod_1.z.nativeEnum(signer_1.SignerStatusEnum)).optional(),
    page: zod_1.z.string().regex(/^\d+$/).transform(Number).optional(),
    page_size: zod_1.z.string().regex(/^\d+$/).transform(Number).optional(),
});
var CreatePacketDocumentType;
(function (CreatePacketDocumentType) {
    CreatePacketDocumentType[CreatePacketDocumentType["BASE_64"] = 0] = "BASE_64";
    CreatePacketDocumentType[CreatePacketDocumentType["DASHBOARD"] = 1] = "DASHBOARD";
})(CreatePacketDocumentType = exports.CreatePacketDocumentType || (exports.CreatePacketDocumentType = {}));
exports.Base64Document = zod_1.z.object({
    type: zod_1.z.literal(CreatePacketDocumentType.BASE_64),
    base64: zod_1.z.string(),
    file_name: zod_1.z.string(),
});
exports.DashboardDocumentInfoDto = zod_1.z.object({
    id: zod_1.z.number(),
    plan_id: zod_1.z.number(),
    period_id: zod_1.z.number(),
});
exports.DashboardDocument = zod_1.z.object({
    type: zod_1.z.literal(CreatePacketDocumentType.DASHBOARD),
    creditor_id: zod_1.z.string().min(1),
    dashboards: zod_1.z.array(exports.DashboardDocumentInfoDto),
});
exports.CreatePacketDocumentDto = zod_1.z.discriminatedUnion('type', [
    exports.Base64Document,
    exports.DashboardDocument,
]);
// patch packet types request
const PACKET_STATUS_CANCEL = {
    [types_1.PacketTypeEnum.DOCUMENT_SIGNATURE]: types_1.DocumentSignatureStatusEnum.CANCELED,
    [types_1.PacketTypeEnum.POLICY_AGREEMENT]: types_1.PolicyAgreementStatusEnum.REVOKED,
};
const getStatusOfCanceledPacket = (packetType) => {
    return PACKET_STATUS_CANCEL[packetType];
};
exports.getStatusOfCanceledPacket = getStatusOfCanceledPacket;
const PACKET_STATUS_FINISHED = {
    [types_1.PacketTypeEnum.DOCUMENT_SIGNATURE]: types_1.DocumentSignatureStatusEnum.SIGNED,
    [types_1.PacketTypeEnum.POLICY_AGREEMENT]: types_1.PolicyAgreementStatusEnum.SIGNED,
};
const getStatusOfFinishedPacket = (packetType) => {
    return PACKET_STATUS_FINISHED[packetType];
};
exports.getStatusOfFinishedPacket = getStatusOfFinishedPacket;
exports.DeletePacketsRequestSchema = zod_1.z.object({
    packet_ids: zod_1.z.array(zod_1.z.number()).min(1),
});
